import { render } from "./TicketDetails.vue?vue&type=template&id=01948986"
import script from "./TicketDetails.vue?vue&type=script&lang=js"
export * from "./TicketDetails.vue?vue&type=script&lang=js"
script.render = render

export default script